window.Products.HomeDecor = {};
window.Products.HomeDecor.HomeDecor = function(){};
window.Products.HomeDecor.HomeDecor.inherits(window.Products.Product);
window.Products.HomeDecor.HomeDecor.dpi = 150;